function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82323 3.22182C9.1983 2.84675 9.70701 2.63604 10.2374 2.63604H15.364C16.4685 2.63604 17.364 3.53147 17.364 4.63604V9.76256C17.364 10.293 17.1533 10.8017 16.7782 11.1768L10.0277 17.9272C9.24668 18.7083 7.98035 18.7083 7.19931 17.9272L2.07278 12.8007C1.29173 12.0196 1.29173 10.7533 2.07278 9.97227L8.82323 3.22182Z",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8284 8.29289C13.2427 8.87868 12.2929 8.87868 11.7071 8.29289C11.1213 7.7071 11.1213 6.75736 11.7071 6.17157C12.2929 5.58578 13.2427 5.58578 13.8284 6.17157C14.4142 6.75736 14.4142 7.7071 13.8284 8.29289Z",
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 4.9896,
  y1: 12.182,
  x2: 7.81803,
  y2: 15.0104,
  stroke: "black"
});

var SvgProduct = function SvgProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product.177f2d9a.svg";
export { ForwardRef as ReactComponent };